import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Body1, Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { WarningIcon } from '@ui/icons/Warning.icon'

import { PersonalDetailsTemplate } from '../PersonalDetailsTemplate'

import styles from '../PersonalDetailsPage.module.scss'

export const PersonalDetailsStepUSPage: React.FC = () => {
  const navigate = useNavigate()
  const goBack = () => navigate('../')

  return (
    <PersonalDetailsTemplate step={1} USStep goBack={goBack}>
      <USCitizenWarning onGoBack={goBack} />
    </PersonalDetailsTemplate>
  )
}

const USCitizenWarning = ({ onGoBack }: { onGoBack: () => void }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={styles.usWarning}>
      <div className={styles.usWarningHeader}>
        <WarningIcon color='text-danger-high-em' size={18} />
        <Heading6 medium>{t('Sign up.US Citizen')}</Heading6>
      </div>
      <p className={styles.subtitle}>
        {t("Sign up.Unfortunately, we can't offer our services to US citizens")}
      </p>
      <Body1 isParagraph className={styles.text}>
        {t('Sign up.A US Citizen has been defined by the IRS as')}
      </Body1>
      <ul className={styles.list}>
        <li className={styles.text}>
          {t('Sign up.USCitizenConditions.An individual born in the United States')}
        </li>
        <li className={styles.text}>
          {t('Sign up.USCitizenConditions.An individual whose parent is a US citizen')}
        </li>
        <li className={styles.text}>
          {t(
            'Sign up.USCitizenConditions.An individual born in Puerto Rico, Guam or the US Virgin Islands'
          )}
        </li>
        <li className={styles.text}>
          {t('Sign up.USCitizenConditions.A former alien who has been naturalized as a US citizen')}
        </li>
      </ul>
      <div className={styles.buttonWrapper}>
        <Button.Secondary size='lg' onClick={() => onGoBack()}>
          {t("Sign up.I'm Not a US Citizen")}
        </Button.Secondary>
        <Button.Primary size='lg' onClick={() => navigate('/login')}>
          {t("Sign up.I'm a US Citizen")}
        </Button.Primary>
      </div>
    </div>
  )
}
